var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9950_143512",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9950_143512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_2",
    d: "M8.00004 10.3845L5.64106 8.02555L6.11286 7.54607L7.66671 9.09992V3.33325H8.33337V9.09992L9.88722 7.54607L10.359 8.02555L8.00004 10.3845ZM4.41029 12.6666C4.10346 12.6666 3.84726 12.5638 3.64171 12.3583C3.43615 12.1527 3.33337 11.8965 3.33337 11.5897V9.97429H4.00004V11.5897C4.00004 11.6922 4.04277 11.7862 4.12824 11.8717C4.21372 11.9572 4.30773 11.9999 4.41029 11.9999H11.5898C11.6923 11.9999 11.7864 11.9572 11.8718 11.8717C11.9573 11.7862 12 11.6922 12 11.5897V9.97429H12.6667V11.5897C12.6667 11.8965 12.5639 12.1527 12.3584 12.3583C12.1528 12.5638 11.8966 12.6666 11.5898 12.6666H4.41029Z",
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDash);
export default __webpack_public_path__ + "static/media/downloadDash.848e5a6bc8ca505ca3423adfc86bd228.svg";
export { ForwardRef as ReactComponent };